import {
  createEntityAdapter,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';
import { createBusinessContactThunk } from './thunks/createBusinessContact.thunk';
import { getBusinessContactsThunk } from './thunks/getBusinessContacts.thunk';

export { createBusinessContactThunk, getBusinessContactsThunk };

const contactsAdapter = createEntityAdapter();

export const contactsSlice = createSlice({
  name: 'contacts',
  initialState: {
    contacts: contactsAdapter.getInitialState(),
    loadedForBusinessId: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(createBusinessContactThunk.fulfilled, (state, action) => {
        if (action.payload) {
          contactsAdapter.upsertOne(state.contacts, action.payload);
        }
      })
      .addCase(getBusinessContactsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getBusinessContactsThunk.fulfilled, (state, action) => {
        const contacts = action.payload ?? [];
        contactsAdapter.setAll(state.contacts, contacts);
        state.loading = false;
      })
      .addCase(getBusinessContactsThunk.rejected, (state) => {
        state.loading = false;
        state.error = true;
      });
  },
});

export const contactsAdapterSelectors = contactsAdapter.getSelectors(
  (state) => state.contacts.contacts
);

export const selectContactsLoading = (state) => state.contacts.loading;
export const selectContactsLoadedForBusinessId = (state) =>
  state.contacts.loadedForBusinessId;

export const selectContactsWithEmail = createSelector(
  contactsAdapterSelectors.selectAll,
  (contacts) => contacts.filter((c) => !!c.emailAddress)
);
